import { httpClient } from "./RestService";

export const health = async () => {
  return await httpClient().get("/actuator/health");
};
